var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 657,
    viewBox: "0 0 1280 657",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_153_1217)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 657,
    rx: 16,
    fill: "#008B39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -104.5,
    y: -43.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: -43.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -104.5,
    y: 105.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 105.5,
    width: 148,
    height: 148,
    rx: 15.5,
    fill: "white",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 105.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -104.5,
    y: 254.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 254.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -104.5,
    y: 403.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 403.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -104.5,
    y: 552.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 552.5,
    width: 148,
    height: 148,
    rx: 15.5,
    fill: "white",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 552.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.5,
    y: -43.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.5,
    y: -43.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.5,
    y: 105.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.5,
    y: 105.5,
    width: 148,
    height: 148,
    rx: 15.5,
    fill: "white",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.5,
    y: 105.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.5,
    y: 254.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.5,
    y: 254.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.5,
    y: 403.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.5,
    y: 403.5,
    width: 148,
    height: 148,
    rx: 15.5,
    fill: "white",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.5,
    y: 403.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.5,
    y: 552.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.5,
    y: 552.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 491.5,
    y: -43.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.5,
    y: -43.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 491.5,
    y: 105.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.5,
    y: 105.5,
    width: 148,
    height: 148,
    rx: 15.5,
    fill: "white",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.5,
    y: 105.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 491.5,
    y: 254.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.5,
    y: 254.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 491.5,
    y: 403.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.5,
    y: 403.5,
    width: 148,
    height: 148,
    rx: 15.5,
    fill: "white",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.5,
    y: 403.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 491.5,
    y: 552.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.5,
    y: 552.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789.5,
    y: -43.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 938.5,
    y: -43.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789.5,
    y: 105.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 938.5,
    y: 105.5,
    width: 148,
    height: 148,
    rx: 15.5,
    fill: "white",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 938.5,
    y: 105.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789.5,
    y: 254.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 938.5,
    y: 254.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789.5,
    y: 403.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 938.5,
    y: 403.5,
    width: 148,
    height: 148,
    rx: 15.5,
    fill: "white",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 938.5,
    y: 403.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789.5,
    y: 552.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 938.5,
    y: 552.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1087.5,
    y: -43.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1236.5,
    y: -43.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1087.5,
    y: 105.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1236.5,
    y: 105.5,
    width: 148,
    height: 148,
    rx: 15.5,
    fill: "white",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1236.5,
    y: 105.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1087.5,
    y: 254.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1236.5,
    y: 254.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1087.5,
    y: 403.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1236.5,
    y: 403.5,
    width: 148,
    height: 148,
    rx: 15.5,
    fill: "white",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1236.5,
    y: 403.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1087.5,
    y: 552.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1236.5,
    y: 552.5,
    width: 148,
    height: 148,
    rx: 15.5,
    stroke: "#00973E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_153_1217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 657,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHero);
export default __webpack_public_path__ + "static/media/HomeHero.67aef7ba105e1c8470dd4a4995d6ff18.svg";
export { ForwardRef as ReactComponent };